import styled from "styled-components";

export const Container = styled.div`
  padding: ${(props) => props.theme.padding.mobile} 20px;

  @media (min-width: 640px) {
    padding: ${(props) => props.theme.padding.primary} 20px;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: 700px;
  margin: 0 auto;

  > h1 {
    text-align: center;
  }
`;

export const FormReembolso = styled.form`
  margin-bottom: 32px;
  display: grid;
  width: 100%;

  gap: 24px 16px;
  grid-template-columns: 1fr;
  grid-template-areas: "motivo" "title" "nome" "cpf" "banco" "agencia" "conta" "operacao" "file" "button";

  > :nth-child(1) {
    grid-area: motivo;

    div#motivo {
      margin-bottom: 24px;
    }

    #textarea {
      height: 210px;
    }
  }

  > :nth-child(2) {
    grid-area: title;

    h2 {
      color: #2d2d2d;
      text-align: center;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 24px;
    }
  }

  > :nth-child(3) {
    grid-area: nome;
  }
  > :nth-child(4) {
    grid-area: cpf;
  }
  > :nth-child(5) {
    grid-area: banco;
  }
  > :nth-child(6) {
    grid-area: agencia;
  }
  > :nth-child(7) {
    grid-area: conta;
  }
  > :nth-child(8) {
    grid-area: operacao;
  }
  > :nth-child(9) {
    grid-area: file;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
  > :nth-child(10) {
    grid-area: button;
    display: flex;
    justify-content: center;
  }

  @media (min-width: 640px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-areas: "motivo motivo motivo motivo" "title title title title" "nome nome nome nome" "cpf cpf cpf cpf" "banco agencia conta operacao" "file file file file" "button button button button";

    > :nth-child(1) {
      #textarea {
        height: 170px;
      }
    }
  }
`;

export const Info = styled.div`
  padding: 13px 15px;
  background: #e8e8e8;
  color: #2d2d2d;
  font-size: 16px;
  font-style: normal;
  width: fit-content;
  text-align: center;
  margin: 0 auto;
  max-width: 1100px;
  font-weight: 400;
  line-height: 24px;

  span {
    color: #ed0000;
  }
`;
